import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Es seguro para recién nacidos?',
  answer: 'Sí, el manual incluye una sección específica de hidrolatos suaves para bebés de 0 a 3 meses.'
}, {
  question: '¿Dónde compro los aceites?',
  answer: 'Te damos enlaces directos a marcas de confianza disponibles en México.'
}, {
  question: '¿Necesito ser experto en botánica?',
  answer: "Para nada. Los protocolos son 'recetas' simples de mezclar."
}, {
  question: '¿Sustituye al pediatra?',
  answer: 'No. Te enseña a manejar lo cotidiano en casa y a identificar cuándo la ayuda profesional es realmente necesaria.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-cream-dark/20" data-id="element-34">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-37">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-sage/30 mx-auto rounded-full" data-id="element-38"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-xl border border-cream-dark overflow-hidden shadow-sm" data-id="element-40">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-inset" aria-expanded={openIndex === index} data-id="element-41">
                <span className="font-playfair font-semibold text-lg text-brown-heading pr-4" data-id="element-42">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-43" />
              </button>

              <AnimatePresence initial={false} data-id="element-44">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-45">
                    <div className="px-6 pb-5 text-brown-body leading-relaxed border-t border-cream/50 pt-3" data-id="element-46">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}